module.exports = __webpack_public_path__ + "images/project-pin-67e127265ead7d6ed9cda1bc1e233ca1.png";